export default "__VITE_ASSET__CVtXpNUM__"